<template>
  <div class="product-variant-picker">
    <div class="product-variant-picker__title">
      <span>
        {{
          $textDictionary['pdp.copilot.title.label'] ??
          'pdp.copilot.title.label'
        }}
      </span>
    </div>
    <div v-if="coPilotUrl !== null">
      <div class="p-4">
        <Button
          v-if="store.decoratedProduct?.sku"
          style-type="primary"
          class="w-100 ms-2 mb-4"
          icon-type="icon-left"
          icon-name="focal-length"
          @click="
            showModal = true;
            generateCoPilotUrl(store.decoratedProduct?.sku);
          "
        >
          {{ $textDictionary['pdp.copilot.button'] ?? 'pdp.copilot.button' }}
        </Button>
      </div>

      <ModalModule
        v-model="showModal"
        :title="
          $textDictionary['pdp.copilot.modal.headline'] ??
          'pdp.copilot.modal.headline'
        "
        close-icon-text="close"
        :is-full-screen="true"
        :esc-to-close="true"
        :click-to-close="true"
        @close="showModal = false"
        @abort="showModal = false"
      >
        <iframe
          :src="coPilotUrl"
          style="width: 100%; height: 100%; min-height: 450px"
        ></iframe>
      </ModalModule>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Button, ModalModule } from '@hypercodestudio/basler-components';
import { useProductDetailPageStore } from '~/stores/productDetailPageStore/productDetailPageStore';
import { useCartStore } from '~/stores/cartStore/cartStore';

const { $textDictionary } = useNuxtApp();
const store = useProductDetailPageStore();
const showModal = ref(false);
const coPilotUrl = ref();
const cartStore = useCartStore();

async function generateCoPilotUrl(sku: string) {
  if (isEmpty(cartStore.cartIds.cart)) {
    await cartStore.loadCart('cart');
  }
  if (isEmpty(cartStore.cartIds.requestCart)) {
    await cartStore.loadCart('requestCart');
  }
  const base =
    'https://copilotstudio.microsoft.com/environments/Default-744babbe-2423-4ffc-a968-eb9943b74386/bots/cr8a2_bruce/webchat?__version__=2';
  const skuParam = '&sku=' + sku;
  const pdpCart = '&pdpCart=' + JSON.stringify(cartStore.cartIds.cart);
  const pdpRequestCart =
    '&pdpRequestCart=' + JSON.stringify(cartStore.cartIds.requestCart);

  coPilotUrl.value = base + skuParam + pdpCart + pdpRequestCart;
}
</script>
